import * as React from "react";
import { Stack } from "@chakra-ui/react";

import IconCircle from "components/Chakra/Icons/Circle";
import IconSuccessCircle from "components/Chakra/Icons/SuccessCircle";

type TColorType = "gray" | "green";

interface IBullet {
  color: TColorType;
  content: React.ReactNode;
}

interface IProps {
  lines: Array<IBullet>;
}

const BulletList: React.FunctionComponent<IProps> = ({ lines }) => (
  <Stack w="16.25rem" px="1rem">
    {lines.map(({ content, color }, i) => (
      <Stack key={i} direction="row" spacing="0.25rem">
        <Stack w="1.25rem" pt={color === "green" ? "0.125rem" : "0.25rem"}>
          {color === "green" ? (
            <IconSuccessCircle
              fillWith="ud-success"
              boxSize="0.938rem"
              ml="0rem"
            />
          ) : (
            <IconCircle
              fillWith="ud-grey-300"
              boxSize="0.625.rem"
              ml="0.125rem"
            />
          )}
        </Stack>
        <Stack w="13.125rem" spacing="0">
          {content}
        </Stack>
      </Stack>
    ))}
  </Stack>
);

export default BulletList;
